import React, {useState} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons'

//source: https://designly.biz/blog/post/react-markdown-how-to-create-a-copy-code-button

export default function CodeCopyButton({ children }) {
    const [copyOk, setCopyOk] = useState(false);

    const iconColor = copyOk ? '#0af20a' : '#474747';
    //const icon = copyOk ? 'fa-check-square-o' : 'fa-copy';

    const handleClick = (e) => {
        navigator.clipboard.writeText(children);
        setCopyOk(true);
        setTimeout(() => {
            setCopyOk(false);
        }, 500);
    }

    return (
        <div className="code-copy-btn"onClick={handleClick} style={{color: iconColor}}>
            <FontAwesomeIcon icon={copyOk ? faCheckSquare : faCopy} />
        </div>
    )
}